import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
} from '@mui/material';

const FormTextInput = ({
  label,
  id,
  value,
  placeholder = `Enter ${label}`,
  onChange,
  sx,
  type = 'text',
  leadingIcon,
  trailingIcon,
  onIconClick,
  required = false,
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <FormControl
      fullWidth
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TextField
        id={id}
        variant="outlined"
        fullWidth
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        InputProps={{
          startAdornment: leadingIcon ? (
            <InputAdornment position="start" sx={{ marginRight: '-14px' }}>
              <IconButton
                onClick={onIconClick}
                sx={{ color: 'var(--gray-400)' }}
              >
                {leadingIcon}
              </IconButton>
            </InputAdornment>
          ) : null,
          endAdornment: trailingIcon ? (
            <InputAdornment position="end">
              <IconButton
                onClick={onIconClick}
                edge="end"
                sx={{ color: 'var(--gray-400)', padding: '10px' }}
              >
                {trailingIcon}
              </IconButton>
            </InputAdornment>
          ) : null,
          sx: {
            borderRadius: '10px',
            backgroundColor: 'var(--white)',
            fontSize: '1rem',
            // color: 'var(--navyBlue-default)',
            '& .MuiInputBase-input': {
              color: value ? 'var(--black)' : 'var(--gray-500)', // Placeholder gray, value black
            },
            '& fieldset': {
              borderColor: 'var(--gray-300)',
            },
            '&:hover fieldset': {
              borderColor: 'var(--gray-300) !important',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--navyBlue-default) !important',
            },
            '& .MuiOutlinedInput-input': {
              padding: '12px',
            },
            '&.Mui-disabled': {
              backgroundColor: 'var(--gray-100)',
              color: 'var(--gray-300)',
              cursor: 'not-allowed',
              '& fieldset': {
                borderColor: 'var(--gray-300) !important',
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'var(--gray-500)', // Change this to your preferred color
              opacity: 2, // Ensure visibility (default opacity is lower in some browsers)
            },
          },
        }}
        sx={sx}
        required={required ?? false}
        disabled={disabled ?? false}
      />
    </FormControl>
  );
};

export default FormTextInput;
